import React from 'react';
import cn from 'classname';

import Row from './row';
import './main.less';

const Table = props => {
	const { table, intl, sortColumn, changeSort }  = props;

	return (
		<div className="table-container guarant-limited-table">
			<table className="simple-table">
				<thead className="simple-table__head font-roboto-medium sticky-top-0">
					<tr>
						{
							table.headers
								.filter(header => header.index !== 'profit_usd' || !!props.isProfitVisible)
								.map((header, i) =>
									<th
										key={i}
										className={cn({
											[header.className]: true,
											[sortColumn.direction]: Array.isArray(header.index)
												? header.index.includes(sortColumn.col)
												: sortColumn.col === header.index,
											'active': Array.isArray(header.index)
												? header.index.includes(sortColumn.col)
												: sortColumn.col === header.index
										})}
										onClick={changeSort.bind(null, header)}
									>
										{Array.isArray(header.title)
											? header.title.map(
												(item, index) =>
													<span
														key={index}
														onClick={changeSort.bind(null, { index: header.index[index], isSortable: true })}
													>
														{intl(item)}/
													</span>
											)
											: <span>{intl(header.title)}</span>
										}
									</th>
								)
						}
					</tr>
				</thead>
				<tbody className="simple-table__body">
					{table.rows.map((row, i) =>
						<Row key={i} row={row} {...props} />
					)}

				</tbody>
			</table>
		</div>
	);
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/limited-garants-analysis/list/components/table/main.js